import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.7179 5.49162C15.1435 5.49162 14.6093 5.5797 14.1153 5.75586C13.6212 5.93202 13.1712 6.10627 12.7653 6.27859C12.3594 6.45093 12.007 6.5371 11.7083 6.5371C11.3943 6.5371 11.0458 6.45476 10.6629 6.29009C10.2799 6.12542 9.86823 5.96266 9.42782 5.80182C8.98742 5.64097 8.5183 5.56055 8.02046 5.56055C7.07838 5.56055 6.17076 5.81713 5.29762 6.3303C4.42447 6.84347 3.70834 7.60172 3.14923 8.60507C2.59011 9.60842 2.31055 10.8454 2.31055 12.316C2.31055 13.235 2.41778 14.1541 2.63223 15.0732C2.84669 15.9924 3.13391 16.8617 3.49389 17.6812C3.85387 18.5007 4.25214 19.2245 4.68871 19.8526C5.25549 20.6415 5.80887 21.3193 6.34884 21.886C6.88881 22.4529 7.51495 22.7363 8.22726 22.7363C8.69446 22.7363 9.10039 22.6597 9.44505 22.5065C9.78972 22.3532 10.1554 22.1982 10.5422 22.0412C10.929 21.8842 11.4135 21.8057 11.9956 21.8057C12.4398 21.8057 12.8113 21.8516 13.11 21.9434C13.4087 22.0354 13.6825 22.1407 13.9314 22.2594C14.1803 22.3782 14.4427 22.4835 14.7184 22.5754C14.9941 22.6673 15.3273 22.7132 15.7179 22.7132C16.2311 22.7132 16.6925 22.5773 17.1023 22.3054C17.5121 22.0335 17.8912 21.6831 18.2396 21.2542C18.5882 20.8252 18.9271 20.3772 19.2565 19.91C19.6164 19.3815 19.9094 18.8741 20.1354 18.3878C20.3613 17.9014 20.5279 17.5031 20.6351 17.193C20.7423 16.8828 20.7998 16.7123 20.8075 16.6817C20.7845 16.674 20.6179 16.5878 20.3077 16.4232C19.9975 16.2585 19.6451 15.9962 19.2507 15.6362C18.8563 15.2762 18.5116 14.8051 18.2167 14.223C17.9218 13.641 17.7744 12.9287 17.7744 12.0861C17.7744 11.3509 17.8912 10.7171 18.1248 10.1848C18.3584 9.65247 18.6322 9.21206 18.9462 8.86357C19.2603 8.51507 19.5417 8.24892 19.7907 8.0651C20.0396 7.88128 20.1832 7.77788 20.2215 7.75491C19.8385 7.20344 19.4211 6.77453 18.9693 6.46817C18.5174 6.1618 18.0731 5.93968 17.6365 5.80182C17.1999 5.66395 16.8112 5.57778 16.4704 5.54331C16.1296 5.50885 15.8788 5.49162 15.7179 5.49162ZM14.9137 3.63045C15.266 3.20919 15.5532 2.72092 15.7753 2.16563C15.9975 1.61034 16.1085 1.03781 16.1085 0.448061C16.1085 0.27956 16.097 0.130206 16.074 0C15.4996 0.0229775 14.9003 0.195309 14.2761 0.516993C13.6519 0.838678 13.1368 1.24078 12.7308 1.72331C12.4015 2.09095 12.1104 2.5505 11.8577 3.10196C11.6049 3.65342 11.4786 4.22019 11.4786 4.80229C11.4786 4.89421 11.4843 4.97846 11.4958 5.05505C11.5073 5.13164 11.5169 5.18525 11.5245 5.21589C11.6241 5.23887 11.7275 5.25036 11.8347 5.25036C12.3479 5.25036 12.8936 5.09717 13.4719 4.79081C14.0501 4.48444 14.5307 4.09765 14.9137 3.63045Z"}}]};

const LogoAppleFilled = Vue.extend<IconProps>({
  name: 'LogoAppleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-apple-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoAppleFilled;
